import { render } from "./Lists.vue?vue&type=template&id=13e75456&scoped=true"
import script from "./Lists.vue?vue&type=script&lang=ts"
export * from "./Lists.vue?vue&type=script&lang=ts"

import "./Lists.vue?vue&type=style&index=0&id=13e75456&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-13e75456"

export default script